import { render, staticRenderFns } from "./roseChart.vue?vue&type=template&id=06e67ef1&scoped=true"
import script from "./roseChart.vue?vue&type=script&lang=js"
export * from "./roseChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e67ef1",
  null
  
)

export default component.exports